var Rebase = require("re-base");
var firebase = require("firebase");
var prodApp = firebase.initializeApp({
  apiKey: "AIzaSyAX5g_oDJQXjkjbJAWECioBkoi_s89cvjc",
  authDomain: "reflekt-39a81.firebaseapp.com",
  databaseURL: "https://reflekt-39a81.firebaseio.com",
  projectId: "reflekt-39a81",
  storageBucket: "reflekt-39a81.appspot.com",
  messagingSenderId: "982799956858"
});

var app = prodApp;
// var devApp = firebase.initializeApp({
//     apiKey: "AIzaSyALsfmpQNv9T5VfNKQsh_pKbUVE46RP3cI",
//     authDomain: "reflekt-dev.firebaseapp.com",
//     databaseURL: "https://reflekt-dev.firebaseio.com",
//     projectId: "reflekt-dev",
//     storageBucket: "reflekt-dev.appspot.com",
//     messagingSenderId: "856717158728"
// });
// var app = devApp;
var base = Rebase.createClass(app.database());
export { base, app, firebase };



// WEBPACK FOOTER //
// ./src/firebase.js